import React from 'react';
import { ContentHeader } from '@croquiscom-pvt/zds';

interface RelatedStylistListHeaderProps {
  main_title: string;
  image_url: string | null;
}
export const RelatedStylistListHeader: React.FC<React.PropsWithChildren<RelatedStylistListHeaderProps>> = ({
  main_title,
  image_url,
}) => {
  return (
    <ContentHeader
      title={main_title.split('\n').map((line) => (
        <React.Fragment key={line}>
          {line}
          <br />
        </React.Fragment>
      ))}
      right={image_url ? [{ type: 'thumbnail', src: image_url, alt: 'thumbnail' }] : []}
    />
  );
};
